import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';

export const UsersLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action='ListUsers' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action='CreateUser' redirectTo='/users'>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action='GetUser' redirectTo='/users'>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
